module.exports = __webpack_public_path__ + "img/banner_mobilplus.589ca296.png";